<template>
    <a-layout id="home" class="page_layout">
        <a-layout-content class="page_content home_content">
            <a-space direction="vertical" :size="16" style="width:100%;">
                <a-row type="flex" justify="space-between" align="top" :gutter="16">
                    <a-col :lg="9" :xl="9" :xxl="12">
                        <a-card :bordered="false" :loading="countLoading">
                            <a-row type="flex" justify="space-around" align="top">
                                <a-statistic
                                    title="客户总数"
                                    :value="detailData.total"
                                    :value-style="{
                                        fontSize: '32px',
                                        fontWeight: 'bold',
                                        textAlign: 'center'
                                    }"
                                >
                                </a-statistic>
                                <a-divider type="vertical" />
                                <a-statistic
                                    title="今日新增"
                                    :value="detailData.add"
                                    :value-style="{
                                        fontSize: '32px',
                                        fontWeight: 'bold',
                                        textAlign: 'center'
                                    }"
                                >
                                </a-statistic>
                                <a-divider type="vertical" />
                                <a-statistic
                                    title="今日流失"
                                    :value="detailData.destroy"
                                    :value-style="{
                                        fontSize: '32px',
                                        fontWeight: 'bold',
                                        textAlign: 'center'
                                    }"
                                >
                                </a-statistic>
                            </a-row>
                        </a-card>
                    </a-col>
                    <a-col :lg="8" :xl="7" :xxl="6">
                        <a-card :bordered="false">
                            <a-card-meta>
                                <a-space align="start" size="middle" slot="avatar">
                                    <a-avatar shape="square" :size="77" :src="detailData.avatar" />
                                    <a-space direction="vertical" :size="5">
                                        <b>
                                            <openData
                                                type="userName"
                                                :openid="detailData.userName"
                                            ></openData>
                                        </b>
                                        <span class="item_txt">管理员</span>
                                        <span class="item_txt">
                                            到期时间：{{ detailData.expTime }}
                                        </span>
                                    </a-space>
                                </a-space>
                            </a-card-meta>
                        </a-card>
                    </a-col>
                    <a-col :lg="7" :xl="8" :xxl="6">
                        <a-card :bordered="false">
                            <a-card-meta>
                                <a-space align="start" size="middle" slot="avatar">
                                    <a-avatar
                                        shape="square"
                                        :size="77"
                                        src="/static/img/server.jpg"
                                    />
                                    <a-space direction="vertical" :size="5">
                                        <b>专属客服</b>
                                        <span class="item_txt">
                                            添加专属客服，在使用过程中遇到任何问题我都会帮你解决
                                        </span>
                                    </a-space>
                                </a-space>
                            </a-card-meta>
                        </a-card>
                    </a-col>
                </a-row>
                <a-card :bordered="false">
                    <a-form-model :model="detailData">
                        <a-form-model-item>
                            <a-radio-group
                                v-model="searchData.type"
                                default-value="total"
                                button-style="solid"
                                @change="typeChange"
                            >
                                <a-radio-button value="total">客户总数</a-radio-button>
                                <a-radio-button value="add">新增客户数</a-radio-button>
                                <a-radio-button value="delete">流失客户数</a-radio-button>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-form-model>
                    <a-form-model :model="detailData" layout="inline">
                        <a-form-model-item>
                            <a-select
                                v-model="timeRange"
                                @change="timeChange"
                                placeholder="选择时间段"
                                style="width: 95px"
                                allowClear
                            >
                                <a-select-option :value="3">最近3天</a-select-option>
                                <a-select-option :value="7">最近7天</a-select-option>
                                <a-select-option :value="15">最近15天</a-select-option>
                            </a-select>
                        </a-form-model-item>
                        <a-form-model-item label="自定义">
                            <a-range-picker
                                v-model="dateTime"
                                allow-clear
                                @change="dateTimeChange"
                            />
                        </a-form-model-item>
                    </a-form-model>
                    <ve-line :data="chartData" :loading="loading" :settings="setting"></ve-line>
                </a-card>
            </a-space>
        </a-layout-content>
    </a-layout>
</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import api from '@/apis';
import openData from '@/components/group/openData';
export default {
    components: {
        openData
    },
    data() {
        return {
            loading: false,
            countLoading: false,
            dateTime: [],
            timeRange: 3,
            searchData: {
                type: 'total',
                startTime: dayjs()
                    .subtract(2, 'day')
                    .unix(),
                endTime: dayjs().unix()
            },
            detailData: {},
            chartData: {
                columns: ['date', 'total'],
                rows: []
            },
            setting: {
                labelMap: { date: '日期', total: '客户数' },
                legendName: { date: '日期', total: '客户数' },
                itemStyle: {
                    normal: {
                        color: '#ff5800',
                        lineStyle: {
                            color: '#ff5800'
                        }
                    }
                }
            }
        };
    },
    mounted() {
        this.detailData.avatar = window.sessionStorage.getItem('avatar');
        this.detailData.userName = window.sessionStorage.getItem('userName');
        this.detailData.expTime = window.sessionStorage.getItem('expTime');
        this.initCount();
        this.initChart();
    },
    methods: {
        async initCount() {
            this.countLoading = true;
            try {
                const res = await api.getCount();
                if (res.code !== 0) return;
                this.countLoading = false;
                this.detailData.total = res.total;
                this.detailData.add = res.add;
                this.detailData.destroy = res.destroy;
            } catch (err) {
                console.log(err);
            }
        },
        async initChart() {
            this.loading = true;
            try {
                const res = await api.getChart(this.searchData);
                if (res.code !== 0) return;
                this.loading = false;
                this.chartData.rows = res.charts;
            } catch (err) {
                console.log(err);
            }
        },
        typeChange(e) {
            this.searchData.type = e.target.value;
            this.initChart();
        },
        timeChange(e) {
            this.timeRange = e;
            switch (e) {
                case 3:
                    this.searchData.startTime = dayjs()
                        .subtract(2, 'day')
                        .unix();
                    this.searchData.endTime = dayjs().unix();
                    break;
                case 7:
                    this.searchData.startTime = dayjs()
                        .subtract(6, 'day')
                        .unix();
                    this.searchData.endTime = dayjs().unix();
                    break;
                case 15:
                    this.searchData.startTime = dayjs()
                        .subtract(14, 'day')
                        .unix();
                    this.searchData.endTime = dayjs().unix();
                    break;
            }
            this.initChart();
        },
        dateTimeChange(date, dateString) {
            if (_.compact(dateString).length > 0) {
                this.searchData.startTime = dayjs(dateString[0]).unix();
                this.searchData.endTime = dayjs(dateString[1]).unix();
            } else {
                this.timeRange = 3;
                this.searchData.startTime = dayjs()
                    .subtract(2, 'day')
                    .unix();
                this.searchData.endTime = dayjs().unix();
            }
            this.initChart();
        }
    }
};
</script>

<style>
#home .home_content {
    background: unset;
    padding: 0;
}
#home .ant-divider-vertical {
    height: 4.9em;
    margin: 0;
}
#home .ant-card-meta-avatar {
    padding-right: 0;
}
@media (max-width: 1280px) {
    #home .ant-card-body {
        padding: 10px;
    }
    #home .item_txt {
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        font-size: 12px;
    }
}
</style>
